<template>
  <div class="portal-page-fill manage-user">
    <div class="user-manager" v-if="refinedUsers">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="$t('search.userplaceholder')"
            v-model="search"
          />
        </div>
        <div class="filters-container">
          <!-- <Tabs /> -->
        </div>
        <div class="create-role">
          <span v-if="
                this.permissions.includes('Create-User')"
            @click="createNewUser"
            class="mdi mdi-plus-circle-outline add"
          ></span>
        </div>
      </div>
    </div>
    <div class="user-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
        <thead>
          <tr class="table-header">
            <!-- <th class="user-table-headers"
              :class="[{ sorting: sort == 'id' }, direction]"
              @click="updateSort('id')"
            >
              {{ $t("user.Id") }}
            </th> -->
            <th class="user-table-headers"
              :class="[{ sorting: sort == 'name' }, direction]"
              @click="updateSort('name')"
            >
              {{ $t("user.name") }}
            </th>
            <th class="user-table-headers"
              :class="[{ sorting: sort == 'email' }, direction]"
              @click="updateSort('email')"
            >
              {{ $t("user.email") }}
            </th>
            <th class="user-table-headers"
              :class="[{ sorting: sort == 'role' }, direction]"
              @click="updateSort('role')"
            >
              {{ $t("user.role") }}
            </th>
            <th class="user-table-headers"
              :class="[{ sorting: sort == 'airline' }, direction]"
              @click="updateSort('airline')"
            >
              Airline
            </th>
            <th class="user-table-headers"
              
              v-if="
                this.permissions.includes('Edit-User') ||
                this.permissions.includes('Delete-User')
              "
            >
              {{ $t("user.action") }}
            </th>
          </tr>
        </thead>
        <PortalTableBody
          :loading="loading"
          variant="user"
          :show-actions="hasActionColumn"
        >
        <template
          v-if="
            this.permissions.includes('Edit-User') &&
            this.permissions.includes('Delete-User')
          "
        >
          <tr v-for="(user, item) in refinedUsers" :key="item" class="table-data">
            <td v-if="user.role != 'Super Admin'">{{ user.name }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.email }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.role }}</td>
            <td v-if="user.role != 'Super Admin'" class="" style="max-width: 550px">
              <div class="airline-bg m-1 px-2 py-1" v-for="airline in user.airlines" v-bind:key="airline.name">
                {{ formatName(airline.name) }}
              </div>
            </td>
            
            <td v-if="!airlineKey.includes('admin') && user.role != 'Super Admin'">
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(user.airlines)" >
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editUser(item)"
                  ></span>
                </div>

                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(item)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else-if="airlineKey.includes('admin') && user.role != 'Super Admin'">
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editUser(item)"
                  ></span>
                </div>

                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(item)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template
          v-else-if="
            this.permissions.includes('Edit-User') &&
            !this.permissions.includes('Delete-User')
          "
        >
          <tr v-for="(user, item) in refinedUsers" :key="item" class="table-data">
            <td v-if="user.role != 'Super Admin'">{{ user.name }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.email }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.role }}</td>
            <td v-if="user.role != 'Super Admin'">
              <span class="airline-bg mx-1 px-2 py-1" v-for="airline in user.airlines" v-bind:key="airline.name">
                {{ formatName(airline.name) }}
              </span>
            </td>
            <td v-if="!airlineKey.includes('admin') && user.role != 'Super Admin' ">
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(user.airlines)">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editUser(item)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else-if="airlineKey.includes('admin') && user.role != 'Super Admin'">
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-pencil edit"
                    @click="editUser(item)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template
          v-else-if="
            !this.permissions.includes('Edit-User') &&
            this.permissions.includes('Delete-User')
          "
        >
          <tr v-for="(user, item) in refinedUsers" :key="item" class="table-data">
            <td v-if="user.role != 'Super Admin'">{{ user.name }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.email }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.role }}</td>
            <td v-if="user.role != 'Super Admin'">
              <span class="airline-bg mx-1 px-2 py-1" v-for="airline in user.airlines" v-bind:key="airline.name">
                {{ formatName(airline.name) }}
              </span>
            </td>
            <td v-if="!airlineKey.includes('admin') && user.role != 'Super Admin'">
              <div class="row d-flex justify-content-center" v-if="checkAirlineAction(user.airlines)">
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(item)"
                  ></span>
                </div>
              </div>
            </td>
            <td v-else-if="airlineKey.includes('admin') && user.role != 'Super Admin'">
              <div class="row d-flex justify-content-center">
                <div class="icon">
                  <span
                    class="mdi mdi-delete delete"
                    @click="openModel(item)"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <template
          v-else-if="
            !this.permissions.includes('Edit-User') &&
            !this.permissions.includes('Delete-User')
          "
        >
          <tr v-for="(user, item) in refinedUsers" :key="item" class="table-data">
            <td v-if="user.role != 'Super Admin'">{{ user.name }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.email }}</td>
            <td v-if="user.role != 'Super Admin'">{{ user.role }}</td>
            <td v-if="user.role != 'Super Admin'">
              <span class="airline-bg mx-1 px-2 py-1" v-for="airline in user.airlines" v-bind:key="airline.name">
                {{ formatName(airline.name) }}
              </span>
            </td>
          </tr>
        </template>
        </PortalTableBody>
      </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        {{ $t("displayresults.display") }} <strong>{{ resultsCopy }}</strong> {{ $t("displayresults.results")}}
      </div>
    </div>
    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>{{ $t("deletepop.message") }}</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      :value="$t('deletepop.okbtn')"
                      @click="deleteUser(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      :value="$t('deletepop.cancelbtn')"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
import { decryptData } from '../../js/utils/encrypt';
import PortalTableBody from '../PortalTableBody.vue';

export default {
  components: {
    PortalTableBody,
  },
  props: {
    direction: String,
    sort: String,
  },
  data() {
    return {
      users: '',
      userid: '',
      loading: false,
      permissions: [],
      modalData: '',
      myModel: false,
      search: '',
      filter: 'all',
      airlineKey: []

    };
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    
    refinedUsers() {
      if (!Array.isArray(this.users)) {
        return [];
      }
      let refined = this.searchUsers(this.users);
      if (this.sort) {
        refined = this.sortUsers(refined);
      }
      return this.direction === 'ascending' ? refined : refined.slice().reverse();
    },
    resultsCopy() {
      const length = this.refinedUsers.length;
      return `${length}`; 
    },
    hasActionColumn() {
      return (
        this.permissions.includes('Edit-User') ||
        this.permissions.includes('Delete-User')
      );
    }
  },
  mounted() {
    this.loading = true;
    let airline = localStorage.getItem('Airline');
    if (!airline) {
      airline = 'null';
    }
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);
    let airlineArray  = decryptData(airline, secretPermissionKey);
    
    if (!Array.isArray(airlineArray) || airlineArray.length === 0) {
      this.airlineKey.push('admin');
    } else {
      for (let i = 0; i < airlineArray.length; i++) {
        this.airlineKey.push(airlineArray[i].name);
      }
    }
    console.log('here', this.airlineKey);
    axios
      .get(this.$hostName + '/getAllUsers')
      .then((response) => {
        this.users = response.data.users;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    refreshPortalPage() {
      this.getUser();
    },
    checkAirlineAction(airlineData){
      for(let i=0; i<airlineData.length; i++){
        if(this.airlineKey.includes(airlineData[i].name)){
          return true;
        }
      }
      return false;
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    createNewUser() {
      if(this.airlineKey == 'admin'){
        this.$router.push({ name:routeNames.newUser});
      }
      else{
        var airline = this.airlineKey;
        this.$router.push({ 
          name: routeNames.newUser,
          params: {
            airline
          }
        });
      }
    },
    editUser(item) {
      this.userid = this.refinedUsers[item].id;
      var userid = this.refinedUsers[item].id;
      var name = this.refinedUsers[item].name;
      var email = this.refinedUsers[item].email;
      var role = this.refinedUsers[item].role;
      var airline = this.refinedUsers[item].airlines;
      console.log('edit check', airline);
      this.$router.push({ 
        name: routeNames.editUser, 
        params: { 
          userid,
          name,
          email,
          role,
          airline
        } 
      });
    },
    deleteUser(item) {
      this.loading = true;
      axios
        .delete(this.$hostName + '/delete/user/' + this.refinedUsers[item].id)
        .then((response) => {
          if (response.status == 200) {
            this.$emit('User Deleted');
            this.myModel = false;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
            this.getUser();
          });
    },
    getUser(){
      axios
      .get(this.$hostName + '/getAllUsers')
      .then((response) => {
        this.users = response.data.users;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
        this.$alert('User removed succesfully');
      });
    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
    formatName(name){
      if(name == null ){
        return name;
      }
      return name.split(/(?=[A-Z])/).join(' ');
    },
    sortUsers(data) {
      const rows = Array.isArray(data) ? data.slice() : [];
      switch (this.sort) {
        case 'id':
        case 'name':
        case 'email':
        case 'role':
        case 'airline':
          return rows.sort((userA, userB) => {
            if (userA[this.sort] < userB[this.sort]) {
              return -1;
            }
            if (userA[this.sort] > userB[this.sort]) {
              return 1;
            }
            return 0;
          });

        default:
          return rows;
      }
    },
    searchUsers(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      return rows.filter((user) => {
        return (
          (user.name &&
            user.name
              .toString()
              .toLowerCase()
              .includes(this.search.toString().toLowerCase())) ||
          (user.id &&
            user.id
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()))
        );
      });
    },
  },
};
</script>

<style scoped lang="scss">
.airline-bg{
  display: inline-block;
    max-width: 250px;
    color: white;
    background-color: rgb(67, 125, 250);
    border-radius: 7px;
}
.footer {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background-color: $general-gray-light;
    padding: 0 25px;
    border-top: solid 1px $general-white;
    position: absolute;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .results {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 20px;
      color: $general-black-light;
    }
  }
.user-table {
  min-height: 0;
}

.add-user {
  text-align: end;
  font-size: xx-large;
}

.add:hover {
  cursor: pointer;
}

#btn-align {
  margin-right: 5%;
  color: white;
}

.user-header {
  margin-left: 5%;
  margin-right: 5%;
}

.delete {
  color: red;
  margin-left: 10px;
}

.delete:hover {
  cursor: pointer;
}

.edit {
  color: blue;
  margin-right: 10px;
}

.edit:hover {
  cursor: pointer;
}

.icon {
  font-size: 25px;
}

.table-data {
  text-align: center;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-content {
  width: 500px !important;
}

.user-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>